import { ScaffoldPage } from '@/components/layout/ScaffoldPage'
import { buildBreadcrumbs } from '@/config/routes'

export default function Alerts() {
  return (
    <ScaffoldPage
      title="Alert Rules"
      description="Define custom alert thresholds and escalation rules."
      breadcrumbs={buildBreadcrumbs('/settings/notifications/alerts')}
      plannedFeatures={[
        'Custom threshold alerts for confidence drops',
        'Profile drift detection notifications',
        'Escalation spike monitoring',
        'API usage limit warnings',
        'Custom webhook triggers for business events',
      ]}
      relatedPages={[
        { label: 'Notification Settings', href: '/settings/notifications/preferences' },
        { label: 'Usage Dashboard', href: '/settings/account/usage' },
      ]}
    />
  )
}
